
export const stepperClasses = () => ({
  root: {
    width: '350px',
  }
})